/**
 * Redacts the secrets a no-login link URL carries: the link token in a
 * `/pay/<token>` or `/links/<token>` path segment, and any `temp_token` query
 * value. Either one opens that customer's documents, so nothing that leaves
 * the browser (error reports, RUM, analytics) may carry them.
 */
export function redactLinkUrl(url: string): string {
  if (typeof url !== 'string') return url;
  return url
    .replace(/(\/(?:pay|links)\/)[^/?#]+/g, '$1[redacted]')
    .replace(/([?&]temp_token=)[^&#]*/gi, '$1[redacted]');
}
